<template>
  <div class="theme-heading">
    <div class="theme-heading__avatar">
      <img src="/static/img/avatar/study.png" loading="lazy" alt="зоозавр"/>
    </div>
    <div class="theme-heading__bullet">Тема 5</div>
    <h1 class="theme-heading__title">Важность посещения ветеринарного врача</h1>
    <p class="theme-heading__text">Что важно знать?</p>
  </div>

  <div class="topic">
    <div class="theme-point"><span class="theme-point__number">1</span>
      <h2 class="theme-point__title">Формула здоровья</h2>
      <div class="theme-point__img">
        <picture>
          <source srcset="/static/img/theme-5/cat-1.webp" type="image/webp">
          <img src="/static/img/theme-5/cat-1.png" alt="Формула здоровья"/>
        </picture>
      </div>
      <p class="theme-point__text">Вы&nbsp;ответственно ухаживаете за&nbsp;своим питомцем: чистите ему зубы, проводите все необходимые обработки, играете с&nbsp;ним. Он&nbsp;хорошо себя чувствует, и&nbsp;вы&nbsp;не&nbsp;наблюдаете признаков для беспокойства.
        <br><br>
        Нужно&nbsp;ли при этом <span class="accent">водить его к&nbsp;врачу</span> на&nbsp;профилактические осмотры? <span class="accent">Обязательно!</span>
        <br><br>

        <span class="accent">Регулярные (раз в&nbsp;полгода для котенка, раз в&nbsp;год для взрослой кошки) визиты</span> к&nbsp;специалисту помогут распознать болезнь на&nbsp;<span class="accent">ранней стадии</span>, когда ее&nbsp;признаки видны только врачу, и&nbsp;<span class="accent">своевременно принять меры</span>.

      </p>
      <div class="theme-point__block">
        <div class="theme-point__block-icon">
          <svg class="icon-paw">
            <use xlink:href="/static/img/sprites/sprite.svg#paw"></use>
          </svg>
        </div>
        <p class="theme-point__block-text">Также врач может определить, нет&nbsp;ли у&nbsp;котенка избыточного веса, и&nbsp;даст консультации по&nbsp;питанию.</p>
      </div>
    </div>
    <div class="theme-point"><span class="theme-point__number">2</span>
      <h2 class="theme-point__title">заболевание мочевыделительной системы</h2>
      <div class="theme-point__slider-block">
        <div class="swiper theme-point__slider" data-theme-point-slider="data-theme-point-slider">
          <div class="swiper-wrapper">
            <div class="swiper-slide theme-point__slide">
              <picture>
                <source srcset="/static/img/theme-5/cat-slider-1-1.webp" type="image/webp">
                <img src="/static/img/theme-5/cat-slider-1-1.png" alt=""/>
              </picture>
            </div>
            <div class="swiper-slide theme-point__slide">
              <picture>
                <source srcset="/static/img/theme-5/cat-slider-1-2.webp" type="image/webp">
                <img src="/static/img/theme-5/cat-slider-1-2.png" alt=""/>
              </picture>
            </div>
            <div class="swiper-slide theme-point__slide">
              <picture>
                <source srcset="/static/img/theme-5/cat-slider-1-3.webp" type="image/webp">
                <img src="/static/img/theme-5/cat-slider-1-3.png" alt=""/>
              </picture>
            </div>
          </div>
          <div class="theme-point__pagination swiper-pagination" data-theme-point-slider-pagination="data-theme-point-slider-pagination"></div>
        </div>
        <span class="theme-point__slider-text">Листайте карусель</span>
      </div>
      <p class="theme-point__text">
        <span class="accent">Заболевания мочевыделительной системы</span> кошек являются причиной №&nbsp;1&nbsp;для обращения в&nbsp;ветеринарную клинику.
        <br><br>
        Очень важно подобрать <span class="accent">правильный и&nbsp;сбалансированный рацион</span> кошке с&nbsp;диагностированным заболеванием мочевыделительной системы.
      </p>
      <div class="theme-point__numbered">
        <div class="theme-point__numbered-title">Причины развития заболевания</div>
        <ul class="theme-point__numbered-list">
          <li class="theme-point__numbered-item"><span class="number">1</span>
            <div>
              <p class="text">Избыточный вес</p>
            </div>
          </li>
          <li class="theme-point__numbered-item"><span class="number">2</span>
            <div>
              <p class="text">Проведенная кастрация/стерилизация</p>
            </div>
          </li>
          <li class="theme-point__numbered-item"><span class="number">3</span>
            <div>
              <p class="text">Недостаточное потребление воды</p>
            </div>
          </li>
          <li class="theme-point__numbered-item"><span class="number">4</span>
            <div>
              <p class="text">Несбалансированное питание</p>
            </div>
          </li>
          <li class="theme-point__numbered-item"><span class="number">5</span>
            <div>
              <p class="text">Порода (британская, персидская, шотландская, сиамская)</p>
            </div>
          </li>
          <li class="theme-point__numbered-item"><span class="number">6</span>
            <div>
              <p class="text">Пол (у&nbsp;кошек чаще страдают самцы)</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="theme-point"><span class="theme-point__number">3</span>
      <h2 class="theme-point__title">А&nbsp;Вы&nbsp;знали?</h2>
      <div class="theme-point__slider-block desktop-grow">
        <div class="swiper theme-point__slider theme-point__slider--shrank" data-theme-point-slider="data-theme-point-slider">
          <div class="swiper-wrapper">
            <div class="swiper-slide theme-point__slide">
              <picture>
                <source srcset="/static/img/theme-5/cat-slider-2-1.webp" type="image/webp">
                <img src="/static/img/theme-5/cat-slider-2-1.png" alt=""/>
              </picture>
            </div>
            <div class="swiper-slide theme-point__slide">
              <picture>
                <source srcset="/static/img/theme-5/cat-slider-2-2.webp" type="image/webp">
                <img src="/static/img/theme-5/cat-slider-2-2.png" alt=""/>
              </picture>
            </div>
            <div class="swiper-slide theme-point__slide">
              <picture>
                <source srcset="/static/img/theme-5/cat-slider-2-3.webp" type="image/webp">
                <img src="/static/img/theme-5/cat-slider-2-3.png" alt=""/>
              </picture>
            </div>
          </div>
          <div class="theme-point__pagination swiper-pagination" data-theme-point-slider-pagination="data-theme-point-slider-pagination"></div>
        </div>
        <span class="theme-point__slider-text">Листайте карусель</span>
      </div>
    </div>
    <div class="theme-point"><span class="theme-point__number">4</span>
      <h2 class="theme-point__title">ПРИЗНАКИ ТОГО, ЧТО ПОРА ЗАПИСАТЬСЯ К&nbsp;ВЕТЕРИНАРНОМУ ВРАЧУ</h2>
      <p class="theme-point__text">Существует несколько признаков, свидетельствующих о&nbsp;том, что кошку необходимо срочно записать на&nbsp;прием к&nbsp;ветеринарному врачу.</p>
      <div class="theme-point__numbered desktop-grow columns-4">
        <div class="theme-point__numbered-title">7 признаков</div>
        <ul class="theme-point__numbered-list">
          <li class="theme-point__numbered-item"><span class="number">1</span>
            <div>
              <p class="text">Рвота</p>
            </div>
          </li>
          <li class="theme-point__numbered-item"><span class="number">2</span>
            <div>
              <p class="text">Понос</p>
            </div>
          </li>
          <li class="theme-point__numbered-item"><span class="number">3</span>
            <div>
              <p class="text">Отказ от пищи</p>
            </div>
          </li>
          <li class="theme-point__numbered-item"><span class="number">4</span>
            <div>
              <p class="text">Изменение походки, резкое снижение веса</p>
            </div>
          </li>
          <li class="theme-point__numbered-item"><span class="number">5</span>
            <div>
              <p class="text">Угнетение, кошка прячется, не&nbsp;идет на&nbsp;контакт</p>
            </div>
          </li>
          <li class="theme-point__numbered-item"><span class="number">6</span>
            <div>
              <p class="text">Кошка пренебрегает гигиеной</p>
            </div>
          </li>
          <li class="theme-point__numbered-item"><span class="number">7</span>
            <div>
              <p class="text">Вокализация (настойчивое мяуканье)</p>
            </div>
          </li>
          <li class="theme-point__numbered-item"><span class="number">8</span>
            <div>
              <p class="text">Агрессия при попытке контакта</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="theme-point"><span class="theme-point__number">5</span>
      <h2 class="theme-point__title">Что взять с&nbsp;собой на&nbsp;прием?</h2>
      <div class="theme-point__img cover">
        <picture>
          <source srcset="/static/img/theme-5/cat-5.webp" type="image/webp">
          <img src="/static/img/theme-5/cat-5.jpg" alt="Что взять с&amp;nbsp;собой на&amp;nbsp;прием?"/>
        </picture>
      </div>
      <p class="theme-point__text">Регулярные визиты в&nbsp;ветеринарную клинику являются <span class="accent">залогом здоровья кошки</span>. Для того, чтобы прием у&nbsp;ветеринарного врача прошел продуктивно, <span class="accent">необходимо заранее к&nbsp;нему подготовиться</span> и&nbsp;взять с&nbsp;собой все необходимое.</p>
      <div class="theme-point__numbered">
        <div class="theme-point__numbered-title">Чек-лист</div>
        <ul class="theme-point__numbered-list">
          <li class="theme-point__numbered-item"><span class="number">1</span>
            <div>
              <p class="text">Документы</p>
            </div>
          </li>
          <li class="theme-point__numbered-item"><span class="number">2</span>
            <div>
              <p class="text">Результаты прошлых анализов</p>
            </div>
          </li>
          <li class="theme-point__numbered-item"><span class="number">3</span>
            <div>
              <p class="text">Переноска</p>
            </div>
          </li>
          <li class="theme-point__numbered-item"><span class="number">4</span>
            <div>
              <p class="text">Игрушка или одеяло со&nbsp;знакомым запахом</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div class="topic__img">
    <img src="/static/img/zoozavr.png" loading="lazy" alt="зоозавр"/>
  </div>

  <button class="btn topic__btn"
  @click="$emit('goToQuiz')"
  onclick="sendEventYM(
     102182679,
     'quiz5_click_btn'
   );"
  >Закрепить знания</button>
</template>

<script>
import { onMounted, onBeforeUnmount } from 'vue'
import { SliderManager } from '@/assets/js/script.js'
import 'swiper/css'
import 'swiper/css/pagination'

export default {
  name: 'LessonCatsTopic5',
  emits: ['goToQuiz'],
  setup() {
    let sliderManager = null

    onMounted(() => {
      sliderManager = new SliderManager()
      sliderManager.init()
    })

    onBeforeUnmount(() => {
      if (sliderManager) {
        sliderManager.destroy()
        sliderManager = null
      }
    })

    return {}
  }
}
</script>

<style scoped>
</style>
